import { createSelector } from 'reselect';

// Types
import { RootState } from 'types/RootState.types';

// Config
import {
  getSelectedCollectionPointSelector,
  getCollectionPointDatesFailedSelector,
  getCollectionPointDatesEmptySelector,
  getCollectionPointDatesApiCallActiveSelector,
  getCollectionPointDetailsCallActiveSelector,
  getCollectionPointDatesSelector,
  getSelectedCollectionTimeSelector,
  getFocusOnSelectedDayMessageSelector,
  getClickAndCollectProceedingToPaymentSelector,
  getCutOffPassedDuringOrderSubmitSelector,
} from '@redux/reducers/click-and-collect/clickAndCollectSelector';
import { getFormValuesSelector } from '@redux/reducers/form/formSelector';
import { getIsGiftReceiptSelectedSelector } from '@redux/reducers/app/appSelector';

// Utils
import { isCollectPlusRelatedType, getCollectionRelatedStore } from '@utils/collection/getCollectPlusRelatedStores';
import { getCollectionPhoneNumber } from '@utils/collection/getCollectionPhoneNumber';
import { ukMobileNumberRequired } from '@utils/collection/ukMobileNumberRequired';

const getCollectionPhoneNumberSelector = (state: RootState) => getCollectionPhoneNumber(state);
const ukMobileNumberRequiredSelector = (state: RootState) => ukMobileNumberRequired(state);
const giftReceiptSelector = (
  state: RootState,
  _: string,
  giftReciptFormId: string,
) => getIsGiftReceiptSelectedSelector(state, giftReciptFormId);

const collectorDetailsSelector = createSelector([
  getSelectedCollectionPointSelector,
  getCollectionPointDatesFailedSelector,
  getCollectionPointDatesEmptySelector,
  getCollectionPointDatesApiCallActiveSelector,
  getFormValuesSelector,
  giftReceiptSelector,
  getCollectionPointDetailsCallActiveSelector,
  getCollectionPointDatesSelector,
  getSelectedCollectionTimeSelector,
  getFocusOnSelectedDayMessageSelector,
  getClickAndCollectProceedingToPaymentSelector,
  getCutOffPassedDuringOrderSubmitSelector,
  getCollectionPhoneNumberSelector,
  ukMobileNumberRequiredSelector,
], (
  selectedCollectionPoint,
  getCollectionPointDatesFailed,
  collectionPointDatesEmpty,
  getCollectionPointDatesApiCallActive,
  collectorDetailsFormValues,
  isGiftReceiptSelected,
  getCollectionPointDetailsCallActive,
  collectionPointDates,
  selectedCollectionTime,
  focusOnSelectedDayMessage,
  proceedingToPayment,
  cutOffPassedDuringOrderSubmit,
  phoneNumber,
  ukMobileNumberIsRequired,
) => {
  const ownerId = selectedCollectionPoint?.ownerId ?? 0;
  const isCollectPlus = isCollectPlusRelatedType(ownerId);
  const showCollectionDatesCalendar = !isCollectPlus;
  const showDateError = getCollectionPointDatesFailed || collectionPointDatesEmpty;
  const showLimitedAvailablityMessage = showCollectionDatesCalendar
    && !showDateError
    && !getCollectionPointDatesApiCallActive;

  return {
    isGiftReceiptSelected,
    showDateError,
    isCollectPlus,
    storeType: getCollectionRelatedStore(ownerId).name,
    collectionPointDatesEmpty,
    showCollectionDatesCalendar,
    getCollectionPointDatesApiCallActive,
    showLimitedAvailablityMessage,
    collectorDetailsFormValues,
    getCollectionPointDetailsCallActive,
    phoneNumber,
    ukMobileNumberIsRequired,
    collectionPointDates,
    selectedDay: selectedCollectionTime,
    focusOnSelectedDayMessage,
    proceedingToPayment,
    cutOffPassedDuringOrderSubmit,
  };
});

export default collectorDetailsSelector;
